import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:5000';

const Footer = () => {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleNewsletter = async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    try {
      const res = await fetch(`${API_BASE}/api/newsletter`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });
      const data = await res.json();
      setStatus({ type: data.success ? 'success' : 'error', msg: data.message });
      if (data.success) setEmail('');
    } catch {
      setStatus({ type: 'error', msg: 'Network error. Please try again.' });
    } finally {
      setLoading(false);
      setTimeout(() => setStatus(null), 5000);
    }
  };

  return (
    <>
      <style>{`
        .footer {
          background: #07071a;
          color: rgba(255,255,255,0.7);
          padding-top: 80px;
          position: relative;
          overflow: hidden;
        }

        /* top edge accent line */
        .footer::before {
          content: '';
          position: absolute;
          top: 0; left: 0; right: 0;
          height: 1px;
          background: linear-gradient(90deg,
            transparent 0%,
            rgba(79,195,247,0.35) 30%,
            rgba(232,96,58,0.5) 60%,
            transparent 100%);
        }

        .footer-top {
          display: grid;
          grid-template-columns: 2fr 1fr 1fr 1.5fr;
          gap: 48px;
          padding-bottom: 56px;
          border-bottom: 1px solid rgba(255,255,255,0.06);
          max-width: 1200px;
          margin: 0 auto;
          padding-left: 24px;
          padding-right: 24px;
        }

        .footer-logo {
          display: flex;
          align-items: center;
          gap: 11px;
          margin-bottom: 20px;
        }

        .footer-logo-icon {
          width: 40px; height: 40px;
          background: var(--secondary, #e8603a);
          border-radius: 10px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 1.15rem;
          font-weight: 900;
          color: white;
          box-shadow: 0 4px 14px rgba(232,96,58,0.3);
        }

        .footer-logo-text .name {
          font-size: 1rem;
          font-weight: 800;
          color: white;
          line-height: 1.1;
          letter-spacing: 0.08em;
        }

        .footer-logo-text .tagline {
          font-size: 0.6rem;
          color: rgba(79,195,247,0.75);
          letter-spacing: 0.22em;
          text-transform: uppercase;
          font-weight: 500;
        }

        .footer-about p {
          font-size: 0.875rem;
          line-height: 1.85;
          margin-bottom: 24px;
          color: rgba(255,255,255,0.5);
        }

        .footer-socials { display: flex; gap: 8px; }

        .social-btn {
          width: 36px; height: 36px;
          border-radius: 9px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 0.85rem;
          font-weight: 700;
          transition: all 0.22s ease;
          cursor: pointer;
          border: 1px solid rgba(255,255,255,0.1);
          background: rgba(255,255,255,0.04);
          color: rgba(255,255,255,0.7);
          text-decoration: none;
        }

        .social-btn:hover {
          background: var(--secondary, #e8603a);
          border-color: var(--secondary, #e8603a);
          color: white;
          transform: translateY(-2px);
          box-shadow: 0 6px 16px rgba(232,96,58,0.35);
        }

        .social-btn-wa:hover {
          background: #25D366 !important;
          border-color: #25D366 !important;
          box-shadow: 0 6px 16px rgba(37,211,102,0.35) !important;
        }

        .footer-heading {
          font-size: 0.78rem;
          font-weight: 700;
          color: rgba(255,255,255,0.9);
          margin-bottom: 20px;
          position: relative;
          letter-spacing: 0.1em;
          text-transform: uppercase;
          padding-bottom: 12px;
        }

        .footer-heading::after {
          content: '';
          position: absolute;
          bottom: 0; left: 0;
          width: 28px; height: 1.5px;
          background: var(--secondary, #e8603a);
          border-radius: 2px;
        }

        .footer-links { list-style: none; padding: 0; margin: 0; }

        .footer-links li { margin-bottom: 10px; }

        .footer-links a {
          color: rgba(255,255,255,0.48);
          font-size: 0.875rem;
          transition: color 0.2s ease, padding-left 0.2s ease;
          display: flex;
          align-items: center;
          gap: 8px;
          text-decoration: none;
        }

        .footer-links a::before {
          content: '';
          display: inline-block;
          width: 4px; height: 4px;
          border-radius: 50%;
          background: var(--secondary, #e8603a);
          flex-shrink: 0;
          opacity: 0.6;
          transition: opacity 0.2s, transform 0.2s;
        }

        .footer-links a:hover {
          color: rgba(255,255,255,0.85);
          padding-left: 4px;
        }

        .footer-links a:hover::before { opacity: 1; transform: scale(1.4); }

        .footer-contact-item {
          display: flex;
          align-items: flex-start;
          gap: 12px;
          margin-bottom: 16px;
          font-size: 0.875rem;
          color: rgba(255,255,255,0.55);
        }

        .contact-icon {
          width: 32px; height: 32px;
          background: rgba(232,96,58,0.1);
          border-radius: 8px;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
          border: 1px solid rgba(232,96,58,0.2);
          color: rgba(232,96,58,0.8);
        }

        .newsletter-form { display: flex; gap: 0; margin-top: 12px; }

        .newsletter-input {
          flex: 1;
          padding: 11px 15px;
          background: rgba(255,255,255,0.05);
          border: 1px solid rgba(255,255,255,0.1);
          border-right: none;
          border-radius: 9px 0 0 9px;
          color: white;
          font-size: 0.875rem;
          outline: none;
          transition: border-color 0.2s, background 0.2s;
        }

        .newsletter-input::placeholder { color: rgba(255,255,255,0.3); }
        .newsletter-input:focus {
          border-color: rgba(232,96,58,0.5);
          background: rgba(255,255,255,0.08);
        }

        .newsletter-btn {
          padding: 11px 16px;
          background: var(--secondary, #e8603a);
          border: none;
          border-radius: 0 9px 9px 0;
          cursor: pointer;
          color: white;
          transition: background 0.2s;
          display: flex;
          align-items: center;
        }

        .newsletter-btn:hover { background: #d4532e; }
        .newsletter-btn:disabled { opacity: 0.6; cursor: not-allowed; }

        .newsletter-msg {
          margin-top: 10px;
          font-size: 0.8rem;
          padding: 8px 12px;
          border-radius: 7px;
        }

        .newsletter-msg.success { background: rgba(34,197,94,0.12); color: rgba(134,239,172,0.9); border: 1px solid rgba(34,197,94,0.2); }
        .newsletter-msg.error   { background: rgba(239,68,68,0.1);  color: rgba(252,165,165,0.9); border: 1px solid rgba(239,68,68,0.2); }

        .footer-bottom {
          background: rgba(0,0,0,0.35);
          padding: 20px 24px;
          border-top: 1px solid rgba(255,255,255,0.04);
        }

        .footer-bottom-inner {
          display: flex;
          align-items: center;
          justify-content: space-between;
          max-width: 1200px;
          margin: 0 auto;
          flex-wrap: wrap;
          gap: 12px;
        }

        .copyright {
          font-size: 0.82rem;
          color: rgba(255,255,255,0.35);
        }

        .copyright span { color: var(--secondary, #e8603a); }

        .footer-bottom-links { display: flex; gap: 20px; }

        .footer-bottom-links a {
          font-size: 0.8rem;
          color: rgba(255,255,255,0.3);
          text-decoration: none;
          transition: color 0.2s ease;
        }

        .footer-bottom-links a:hover { color: rgba(255,255,255,0.7); }

        @media (max-width: 1024px) {
          .footer-top { grid-template-columns: 1fr 1fr; }
        }
        @media (max-width: 640px) {
          .footer-top { grid-template-columns: 1fr; gap: 32px; padding-bottom: 32px; }
          .footer-bottom-inner { flex-direction: column; text-align: center; }
        }
      `}</style>

      <footer className="footer">
        <div className="footer-top">
          {/* About */}
          <div className="footer-about">
            <Link to="/" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} style={{ display:'inline-block', marginBottom:20 }}>
              <div className="footer-logo">
                <img
                  src="/images/logo.jpeg"
                  alt="Saanvi Innovations"
                  style={{
                    height: 52, width: 'auto', maxWidth: 200, objectFit: 'contain', display: 'block',
                    filter: 'invert(1) hue-rotate(180deg) brightness(1.3) saturate(1.6) contrast(1.1)',
                    transition: 'opacity 0.25s ease, transform 0.3s ease',
                  }}
                  onMouseEnter={e => { e.target.style.opacity = '0.85'; e.target.style.transform = 'scale(1.04)'; }}
                  onMouseLeave={e => { e.target.style.opacity = '1'; e.target.style.transform = 'scale(1)'; }}
                  onError={e => {
                    e.target.style.display = 'none';
                    e.target.nextSibling.style.display = 'flex';
                  }}
                />
                {/* Fallback text logo */}
                <div className="footer-logo-fallback" style={{ display:'none', alignItems:'center', gap:10 }}>
                  <div className="footer-logo-icon">S</div>
                  <div className="footer-logo-text">
                    <div className="name">SAANVI</div>
                    <div className="tagline">Innovations</div>
                  </div>
                </div>
              </div>
            </Link>
            <p>
              Saanvi Innovations is a software and web development company established in 2021.
              We deliver innovative, reliable and cost-effective IT solutions to clients worldwide.
            </p>
            <div className="footer-socials">
              <a href="https://facebook.com" target="_blank" rel="noreferrer" className="social-btn">f</a>
              <a href="https://twitter.com" target="_blank" rel="noreferrer" className="social-btn">𝕏</a>
              <a href="https://instagram.com" target="_blank" rel="noreferrer" className="social-btn">📷</a>
              <a href="https://linkedin.com" target="_blank" rel="noreferrer" className="social-btn">in</a>
              <a href="https://youtube.com" target="_blank" rel="noreferrer" className="social-btn">▶</a>
              <a href="https://wa.me/918770329822" target="_blank" rel="noreferrer" className="social-btn social-btn-wa" title="Chat on WhatsApp">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="17" height="17" fill="currentColor">
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
                </svg>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="footer-heading">Quick Links</h4>
            <ul className="footer-links">
              <li><Link to="/">Home</Link></li>
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/services">Services</Link></li>
              <li><Link to="/portfolio">Portfolio</Link></li>
              <li><Link to="/pricing">Pricing</Link></li>
              <li><Link to="/contact">Contact Us</Link></li>
              <li><Link to="/terms">Terms & Conditions</Link></li>
              <li><Link to="/faq">FAQ</Link></li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="footer-heading">Our Services</h4>
            <ul className="footer-links">
              <li><Link to="/services">Website Development</Link></li>
              <li><Link to="/services">Website Design</Link></li>
              <li><Link to="/services">Digital Marketing</Link></li>
              <li><Link to="/services">SEO Services</Link></li>
              <li><Link to="/services">Social Media Optimization</Link></li>
              <li><Link to="/services">Social Media Marketing</Link></li>
            </ul>
          </div>
          {/* Contact & Newsletter */}
          <div>
            <h4 className="footer-heading">Contact Us</h4>
            <div className="footer-contact-item">
              <div className="contact-icon"><svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" strokeWidth="2"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg></div>
              <span>21, Nehru Colony, Near Vivekanand Chauraha, Thatipur, Gwalior (M.P)</span>
            </div>
            <div className="footer-contact-item">
              <div className="contact-icon"><svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" strokeWidth="2"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg></div>
              <span>ceo@saanviInnovation.com</span>
            </div>
            <div className="footer-contact-item">
              <div className="contact-icon"><svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" strokeWidth="2"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 13.7 19.79 19.79 0 0 1 2.12 5.07 2 2 0 0 1 4.11 3h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 10.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/></svg></div>
              <span>+91 8770329822</span>
            </div>
            <h4 className="footer-heading" style={{ marginTop: '24px' }}>Newsletter</h4>
            <p style={{ fontSize: '0.82rem', color: 'rgba(255,255,255,0.5)', marginBottom: '10px' }}>
              Subscribe for latest updates
            </p>
            <form className="newsletter-form" onSubmit={handleNewsletter}>
              <input
                type="email"
                className="newsletter-input"
                placeholder="Your email..."
                value={email}
                onChange={e => setEmail(e.target.value)}
                required
              />
              <button type="submit" className="newsletter-btn" disabled={loading}>
                {loading
                  ? <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="white" strokeWidth="2" style={{animation:'spin 0.7s linear infinite'}}><circle cx="12" cy="12" r="10" strokeOpacity="0.25"/><path d="M12 2a10 10 0 0 1 10 10" /></svg>
                  : <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="white" strokeWidth="2"><line x1="22" y1="2" x2="11" y2="13"/><polygon points="22 2 15 22 11 13 2 9 22 2"/></svg>
                }
              </button>
            </form>
            {status && (
              <div className={`newsletter-msg ${status.type}`}>
                {status.msg}
              </div>
            )}
          </div>
        </div>

        <div className="footer-bottom">
          <div className="footer-bottom-inner">
            <p className="copyright">
              © {new Date().getFullYear()} <span>Saanvi Innovations</span>. All Rights Reserved.
            </p>
            <div className="footer-bottom-links">
              <Link to="/terms">Privacy Policy</Link>
              <Link to="/terms">Terms of Use</Link>
              <Link to="/contact">Support</Link>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
